import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

export default function CookiesBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookies_accepted");
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookies_accepted", "true");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 200, damping: 25 }}
          className="fixed bottom-4 left-4 right-4 z-50 max-w-lg mx-auto"
          dir="rtl"
        >
          <div
            className="rounded-2xl p-4 flex items-start gap-3"
            style={{ background: "#ffffff", border: "1.5px solid #e5e7eb", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}
          >
            <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ background: "#f0fdf4", border: "1.5px solid #bbf7d0" }}>
              <Cookie className="w-4 h-4" style={{ color: "#16a34a" }} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold mb-0.5" style={{ color: "#111111" }}>אנחנו משתמשים בעוגיות</p>
              <p className="text-xs leading-relaxed" style={{ color: "#6b7280" }}>
                אנו משתמשים בעוגיות לשיפור חוויית הגלישה, ניתוח תנועה ומטרות שיווקיות. המשך השימוש מהווה הסכמה.
              </p>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <button
                onClick={accept}
                className="text-xs font-black px-4 py-2 rounded-full"
                style={{ background: "#16a34a", color: "#ffffff" }}
              >
                אישור
              </button>
              <button onClick={accept} style={{ color: "#9ca3af" }}>
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}